import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var UTM_STORAGE_KEY = 'utm_params';
function getUtmParams() {
  // read from session store
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return {};
  }
  try {
    var stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    // Just swallow this error
    return {};
  }
}
export function storeUtmParams() {
  // read all params from location -- anything starting with utm_
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return;
  }
  try {
    var urlParams = new URLSearchParams(window.location.search);

    // Extract all UTM parameters from the URL
    var newUtmParams = Object.fromEntries(_toConsumableArray(urlParams).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.startsWith('utm_');
    }));
    var oldUtmParams = getUtmParams();

    // update session store with new params -- existing params should not be overwritten
    var mergedParams = _objectSpread(_objectSpread({}, newUtmParams), oldUtmParams);
    sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(mergedParams));
  } catch (error) {
    // Just swallow this error
  }
}

// Returns the entire utm payload as a single encoded query param
// Will be combined with other query params when linking to the app store, so we can pass through utm params from the web to the app
// eg https://play.google.com/store/apps/details?id=com.milanote.milanoteApp&hl=en-US&referrer=utm_source%3Dinstagram%26utm_medium%3Dpaid_social%26utm_campaign%3Dcampaign_name
export function getUtmQueryParam() {
  // read params from session store
  var utmParams = getUtmParams();
  if (Object.keys(utmParams).length === 0) return '';

  // encode params into url query string and then encode as a single param value
  var params = new URLSearchParams(utmParams);
  var encodedParams = encodeURIComponent(params.toString());
  return encodedParams;
}